// extracted by mini-css-extract-plugin
export default {"search":"styles_search__Z-yIa","searchInput":"styles_searchInput__8lJ9H"};